import { v4 as uuidv4 } from 'uuid';

const productsData = [
    {
        id: uuidv4(),
        type: "Laundry Detergent",
        name: "Np Persil Power Lvn Washing Gel 2.6kg",
        imgSrc: "ED02044.jpg",
        offer: 7.8,
        priceBefore: 101.95,
        priceAfter: 93.95,
        currency: "LE",
        description: "Give your clothes a spotless cleaning with the Persil Power Lavender Washing Gel. This powerful gel penetrates deep into the fabric to provide effective cleaning by removing tough stains and dirt without leaving any residue any behind. It protects the clothes from damages and color fading. Not only that, but the gel also leaves the clothes with a refreshing scent.",
        descriptionList: ["Protects the fabric from damages", "Ensures effective cleaning", "Doesn't leave any residue behind", "Provides a refreshing and long-lasting fragrance"],
        category: ['Laundry', 'Detergent'],
        brand: "Persil Gel",
    },
    {
        id: uuidv4(),
        type: "Laundry Detergent",
        name: "Tide Auto P. G. Liquid Detergent - 2.5l",
        imgSrc: "ED02098.jpg",
        offer: 15.6,
        priceBefore: 79.95,
        priceAfter: 67.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ['Laundry', 'Detergent'],
        brand: "Tide Gel",
    },
    {
        id: uuidv4(),
        type: "Laundry Detergent",
        name: "NP Persil L/S Powder Color 2.5K",
        imgSrc: "ED01956.jpg",
        offer: 32.3,
        priceBefore: 95.95,
        priceAfter: 64.95,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ['Laundry', 'Detergent'],
        brand: "Persil LS",
    },
    {
        id: uuidv4(),
        type: "Laundry Detergent",
        name: "Np Persil 30% Auto. Gel Black -900g",
        imgSrc: "ED01984.jpg",
        offer: 16.7,
        priceBefore: 35.95,
        priceAfter: 29.95,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ['Laundry', 'Detergent'],
        brand: "Persil Gel",
    },
    {
        id: uuidv4(),
        type: "Laundry Detergent",
        name: "Persil Power Washing Gel - 2.6kg",
        imgSrc: "ED02043.jpg",
        offer: 7.8,
        priceBefore: 101.95,
        priceAfter: 93.95,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ['Laundry', 'Detergent'],
        brand: "Persil Gel",
    },
    {
        id: uuidv4(),
        type: "Laundry Detergent",
        name: "Ariel T. La. 3in1 Detergent Pods - 15 Pc",
        imgSrc: "ED01826.jpg",
        offer: 12.8,
        priceBefore: 85.95,
        priceAfter: 74.95,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ['Laundry', 'Detergent'],
        brand: "Ariel Powder",
    },
    {
        id: uuidv4(),
        type: "Regular Juice",
        name: "Juhayna Pure Cocktail Juice - 1l",
        imgSrc: "LE00901.jpg",
        offer: 14.5,
        priceBefore: 27.5,
        priceAfter: 23.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Juice"],
        brand: "Juhayna",
    },
    {
        id: uuidv4(),
        type: "Regular Juice",
        name: "Rani Float Juice Pineapple240M",
        imgSrc: "LE00962.jpg",
        offer: 15.3,
        priceBefore: 8.25,
        priceAfter: 6.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Juice"],
        brand: "Rani",
    },
    {
        id: uuidv4(),
        type: "Regular Juice",
        name: "Rani Peach Float Drink 240ml",
        imgSrc: "LE00150.jpg",
        offer: 15.3,
        priceBefore: 8.25,
        priceAfter: 6.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Juice"],
        brand: "Rani",
    },
    {
        id: uuidv4(),
        type: "Regular Juice",
        name: "Juhayna Pure Apple Juice - 1l",
        imgSrc: "LE00371.jpg",
        offer: 14.5,
        priceBefore: 27.5,
        priceAfter: 23.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Juice"],
        brand: "Juhayna",
    },
    {
        id: uuidv4(),
        type: "Regular Juice",
        name: "Juhayna Pure Orange Juice - 1l",
        imgSrc: "LE00372.jpg",
        offer: 14.5,
        priceBefore: 27.5,
        priceAfter: 23.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Juice"],
        brand: "Juhayna",
    },
    {
        id: uuidv4(),
        type: "Regular Juice",
        name: "Juhayna Pure Tomato Juice - 1l",
        imgSrc: "LE00890.jpg",
        offer: 14.5,
        priceBefore: 27.5,
        priceAfter: 23.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Juice"],
        brand: "Juhayna",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Ogeu French Natural Mineral Water-0.75l",
        imgSrc: "LG00403.jpg",
        offer: 35,
        priceBefore: 40,
        priceAfter: 26,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Ogeu French",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Nestle Pure Water Bottle - 1.5L x 12",
        imgSrc: "LG00118.jpg",
        offer: 28.8,
        priceBefore: 61.75,
        priceAfter: 43.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Nestle",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Nestle Pure Life Water - 18.9l",
        imgSrc: "LG00168.jpg",
        offer: 13.5,
        priceBefore: 55.5,
        priceAfter: 47.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Nestle",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Nestle Water 600M*20 Bottle",
        imgSrc: "LG00225.jpg",
        offer: 28.8,
        priceBefore: 61.75,
        priceAfter: 43.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Nestle",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Nestle Pure Life Water 6L",
        imgSrc: "LG00250.jpg",
        offer: 12.2,
        priceBefore: 20.5,
        priceAfter: 17.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Nestle",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Dasani Natural Water Bottle - 1.5l",
        imgSrc: "LG00060.jpg",
        offer: 0,
        priceBefore: 0,
        priceAfter: 4.75,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Dasani",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Hayat Natural Water - 6l",
        imgSrc: "LG00086.jpg",
        offer: 0,
        priceBefore: 0,
        priceAfter: 15.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Hayat",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Hayat Natural Water - 19l",
        imgSrc: "LG00104.jpg",
        offer: 0,
        priceBefore: 0,
        priceAfter: 48,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Hayat",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Evian Mineral Water - 500ml",
        imgSrc: "LG00072.png",
        offer: 0,
        priceBefore: 0,
        priceAfter: 33,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Evian",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Sant Anna Water Naturale - 1.5L",
        imgSrc: "LG00380.jpg",
        offer: 0,
        priceBefore: 0,
        priceAfter: 46.25,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "Sant",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "Sanbenedetto Oligominerale.D.P.D.P/N500M",
        imgSrc: "LG00357.jpg",
        offer: 0,
        priceBefore: 0,
        priceAfter: 13.5,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "San Benedetto",
    },
    {
        id: uuidv4(),
        type: "Regular Water",
        name: "San Benedetto Still Water One Way-250m",
        imgSrc: "LG00405.jpg",
        offer: 0,
        priceBefore: 0,
        priceAfter: 21.99,
        currency: "LE",
        description: "",
        descriptionList: [],
        category: ["Beverage", "Water"],
        brand: "San Benedetto",
    },
];

export default productsData;